/**
 * Created by Ning Jiang on 2/22/2019.
 */

import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {ImmortalFruitsGameMode} from "../ImmortalFruitsGameMode";

export class ImmortalFruitsZeroBetController extends ZeroBetController {

    constructor() {
        super();
    }

    public subtractFreespinCounter():boolean {
        return false;
    }

    public showFreespinCounter():boolean {
        return false;
    }
    protected getZeroBetNumberLeft(data:ParsedServerData){
        return data.freespinsLeft
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === ImmortalFruitsGameMode.BONUS_WHEEL;
    }

    shouldShowZeroBetCounter(): boolean {
        return false;
    }

    shouldSubtractZeroBetCounter(): boolean {
        return false;
    }
}